import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, PhoneCall } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Mid-article CTA module — subtle, helpful, not intrusive */
export const ArticleCTA = ({ title, text, buttonText, buttonLink, variant = "default" }) => {
  if (variant === "inline") {
    return (
      <div className="bg-stone-50 border border-stone-200 rounded-xl px-6 py-6 my-10 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-testid="article-cta-inline">
        <div className="flex-1">
          <p className="font-semibold text-stone-800 text-sm mb-1">{title}</p>
          <p className="text-sm text-stone-500">{text}</p>
        </div>
        <Link to={buttonLink} className="flex-shrink-0">
          <Button size="sm" className="gap-2 rounded-full text-sm">
            {buttonText} <ArrowRight className="w-3.5 h-3.5" />
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-primary-bg rounded-2xl p-8 md:p-10 my-12 text-primary-foreground" data-testid="article-cta-block">
      <div className="max-w-2xl mx-auto text-center">
        <PhoneCall className="w-8 h-8 mx-auto mb-4 opacity-80" />
        <h3 className="font-heading text-xl md:text-2xl font-bold mb-3">{title}</h3>
        <p className="text-primary-foreground/80 text-sm md:text-base leading-relaxed mb-6">{text}</p>
        <Link to={buttonLink}>
          <Button size="lg" variant="secondary" className="gap-2 rounded-full font-semibold">
            {buttonText} <ArrowRight className="w-4 h-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
};
